import { render } from "./QuantumReadinessChatbotTabs.vue?vue&type=template&id=3fec1b42"
import script from "./QuantumReadinessChatbotTabs.vue?vue&type=script&lang=js"
export * from "./QuantumReadinessChatbotTabs.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__